// extracted by mini-css-extract-plugin
module.exports = {"heading":"Questions_heading__osVy_","wrapper":"Questions_wrapper__0j3Y7","grid":"Questions_grid__IUoDo","item":"Questions_item__lSCAS"};